
import React, { useMemo } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const ShiftLineChart = React.memo(({ data = {} }) => {
  // Memoize chartData only if data changes
  const chartData = useMemo(() => {
    return Array.isArray(data?.filledResult)
      ? data?.filledResult
      : [];
  }, [data]);


  return (
    <div className="w-full p-4 flex justify-center">
      <LineChart width={700} height={300} data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="label" />
        <YAxis label={{ value: 'Minutes', angle: -90, position: 'insideLeft' }} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="avg_minutes"
          stroke="#8884d8"
          strokeWidth={2}
          dot={{ r: 4 }}
        />
      </LineChart>
    </div>
  );
});

export default ShiftLineChart;
;
